var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accordion"},[_c('div',{staticClass:"accordion-header"},[_vm._m(0),_c('div',[_vm._t("header")],2)]),_c('div',{staticClass:"accordion-content"},[_vm._t("content")],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"accordion-header__icon text-blue-600"},[_c('i',{staticClass:"fas fa-angle-down"})])
}]

export { render, staticRenderFns }